export const ACTIVITIES = [
  "balloon animals",
  "karaoke",
  "gaming lounge",
  "puppy yoga",
  "rock climbing",
  "egg drop challenge",
  "bouncy castle",
  "photobooth",
  "trivia",
  "cooking/baking workshop",
  "hot sauce challenge",
  "lettuce-eating competition",
];
